module.exports = __webpack_public_path__ + "img/Scene-1.509df72e.jpg";